<div class="company-logo">
<div class="flex justify-content-between align-items-center">
    <img src="https://upload.wikimedia.org/wikipedia/commons/c/ce/Coca-Cola_logo.svg" *ngIf="!company_logo" style="width: 138px; height: 52px; object-fit: contain;">
    <img src="{{company_logo}}" *ngIf="company_logo" style="width: 138px; height: auto; object-fit: contain;">
    <img *ngIf="isMobile" (click) = 'hideMenu()' src="../../../../assets/images/crossIcon.svg" alt="">
</div>
</div>
<div *ngIf="isMobile">
    <div class="separator hp">

    </div>
    <div class="account-details-mobile">
        <div class="flex">
            <div class="username-logo">
                <img class="flex align-items-center cursor-pointer profile-image" src="{{userImage}}" *ngIf="userImage" >
            </div>
            <div class="username-details ml-2">
                <h5 class="username-text">{{username}}</h5>
                <h5 *ngIf="companyEditFlag" (click)="navigateToCompanyCreds()" class="underline username-clr">Company Profile</h5>
            </div>
        </div>
    </div>
    <div class="separator hp">
    
    </div>
</div>
<ul class="layout-menu" [ngClass]="{ 'menu-list-mobile': isMobile}" >
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator && item.items[0]?.roles?.includes(role_id) && role_id" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>

<div class="logout-div" *ngIf="isMobile">
    <li class="list-style-none menu-item-pad" (click)='logout()'>
        <img class="icon-pad" height="18px" width="18px" src="../../../../assets/images/logoutIconGrey.svg" alt="">
        <span class="logout-text-clr">Logout</span>
    </li>
</div>
